import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type LookupRequest = { frn: string };

type LookupResponse = {
  companyName: string;
  companyNumber: string;
  registeredAddress: string;
  activeDirectors: string[];
};

export const useSmartCreateLookup = () => {
  const { mutateAsync, isPending, error } = useMutation<
    { data: LookupResponse },
    Error,
    LookupRequest
  >({
    mutationFn: input => api.post<LookupResponse>('admin/smart-create/lookup', input),
  });

  return { lookup: mutateAsync, isLoading: isPending, error };
};
